export default __webpack_public_path__ + "static/media/portal.ac88b606.png";